import React, { Fragment, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import BabaForm from 'components/forms/Index'
import display from 'lib/Display'

const OrderPayWithGiftCardForm = ({
  order,
  urls,
  onOrderModification,
  authenticityToken
}) => {
  const [showGiftCardForm, setShowGiftCardForm] = useState(false)
  const [giftCardToken, setGiftCardToken] = useState('')
  const [errorMessage, setErrorMessage] = useState(order.giftCardErrorMessage)

  const handleAddGiftCardClick = () => {
    setShowGiftCardForm((prev) => !prev)
  }

  const handleGiftCardTokenChange = (object, field, value) => {
    setGiftCardToken(value)
  }

  const successGiftCard = (data) => {
    onOrderModification(data)
    setErrorMessage(data.order.giftCardErrorMessage)
  }

  const errorGiftCard = () => {
    setErrorMessage('Un problème est survenu, veuillez réessayer.')
  }

  const handleGiftCardTokenValidate = useCallback(async () => {
    try {
      const response = await fetch(urls.useGiftCardURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          gift_card_order: { token: giftCardToken },
          authenticity_token: authenticityToken
        }),
        cache: 'no-store'
      })

      if (!response.ok) {
        errorGiftCard()
      }

      const data = await response.json()
      successGiftCard(data)
    } catch (error) {
      errorGiftCard()
    }
  }, [giftCardToken])

  const renderUsedGiftCard = (el) => (
    <div key={el.giftCardToken}>
      Carte Cadeau{' '}
      <strong>
        {el.giftCardToken} - {display.currency(el.amount)}
      </strong>
    </div>
  )

  const giftCardArrow = showGiftCardForm ? (
    <span className="glyphicon glyphicon-menu-up" />
  ) : (
    <span className="glyphicon glyphicon-menu-down" />
  )

  const giftCardNodes = order.preparedGiftCardPayments.map(renderUsedGiftCard)

  return (
    <Fragment>
      <div className="clickable mb-2" onClick={handleAddGiftCardClick}>
        Utiliser une carte cadeau
        {giftCardArrow}
      </div>

      <div className={showGiftCardForm ? '' : 'hidden'}>
        <div className="row">
          <div className="col-xs-6">
            <BabaForm.FormLine>
              <BabaForm.BabaInput
                type="text"
                objectName="order"
                fieldName="gift_card"
                validate={false}
                placeHolder="Numéro de la carte"
                hideLabel={true}
                onChange={handleGiftCardTokenChange}
                required={false}
                onEnterPress={handleGiftCardTokenValidate}
              />
            </BabaForm.FormLine>
          </div>
          <div className="col-xs-6">
            <button
              onClick={handleGiftCardTokenValidate}
              className="btn btn-primary inline-btn"
              disabled={!giftCardToken}>
              Valider
            </button>
          </div>
        </div>
        <div className="row">
          {errorMessage && (
            <div className="col-xs-12 text-danger">{errorMessage}</div>
          )}
        </div>
      </div>
      <div className="col-xs-12">{giftCardNodes}</div>
    </Fragment>
  )
}

OrderPayWithGiftCardForm.propTypes = {
  order: PropTypes.object.isRequired,
  urls: PropTypes.object.isRequired,
  onOrderModification: PropTypes.func,
  authenticityToken: PropTypes.string.isRequired
}

export default OrderPayWithGiftCardForm
